<template>
  <div class="d-none" />
</template>

<script>
/*
  Invisible component whose sole purpose to provide listable management for
  client groups in the EmailRecipientsEditor component, by re-defining
  the special props that change it's API lookup behavior!

  Key thing here is that 'source' is set to 'groups'!
*/

import Listable from '@/components/mixins/listable';

export default {
  name: 'GroupRecipientsListableManager',
  mixins: [Listable],
  props: {
    gsearch: {
      type: String,
      default: '',
    },
    // listable options
    source: {
      type: String,
      default: 'groups',
    },
    getter: {
      type: String,
      default: 'groups',
    },
    mode: {
      type: String,
      default: 'loadMore',
    },
    pageSize: {
      type: Number,
      default: 15,
    },
    noMultiRequest: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    elements(newVal) {
      this.$emit('input', newVal);
    },
    gsearch: {
      immediate: true,
      handler(newVal) {
        this.search = newVal;
      },
    },
    nextPageExists(newVal) {
      if (newVal) this.$emit('incomplete');
      else this.$emit('depleted');
    },
  },
  mounted() {
    this.queryParams = {
      via_client_autocomplete: 1,
      ...this.queryParams,
    };
  },

};
</script>

<style lang="css" scoped>
</style>
